// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"397":"e50bdb03","457":"ddb9b4c6"}[chunkId] + ".chunk.js";
};